import {Table, Header, SpaceBetween, Pagination, Button, Link} from "@amzn/awsui-components-react";
import {useState, useMemo} from "react";
import { COLUMN_DEFINITIONS } from "./ordersTableConfig";
import {generateRedriveExecutionUrl} from "../../../helpers/logUtils";

interface OrderItem {
  orderId: string;
  stage: string;
}

interface OrdersTableProps {
  items: OrderItem[];
  loading: boolean;
  executionId: string;
  stage: string;
}

const PAGE_SIZE = 50;

export function OrdersTable({ items, loading = false, executionId, stage }: OrdersTableProps) {
  const [currentPageIndex, setCurrentPageIndex] = useState(1);

  const paginatedItems = useMemo(() => {
    const startIndex = (currentPageIndex - 1) * PAGE_SIZE;
    const endIndex = startIndex + PAGE_SIZE;
    return items.slice(startIndex, endIndex);
  }, [items, currentPageIndex]);

  const totalPages = Math.ceil(items.length / PAGE_SIZE);

  return (
    <Table
      resizableColumns
      stickyHeader
      columnDefinitions={COLUMN_DEFINITIONS}
      items={paginatedItems}
      loading={loading}
      loadingText={ "Loading orders" }
      selectionType="multi"
      header={
        <Header
          variant="awsui-h1-sticky"
          counter={items.length > 0 ? `(${items.length})` : undefined}
          actions={(
              <Button
                onClick={() => window.open(generateRedriveExecutionUrl(stage, executionId), "_blank") }
                variant="primary"
              >
                View in Console
              </Button>
          )}
        >
          Orders in Redrive Execution {executionId}
        </Header>
      }
      empty={
        <SpaceBetween size="m" alignItems="center">
          <div>No orders found for this execution</div>
        </SpaceBetween>
      }
      pagination={
        items.length > PAGE_SIZE ? (
          <Pagination
            currentPageIndex={currentPageIndex}
            pagesCount={totalPages}
            onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
          />
        ) : undefined
      }
    />
  );
}
